module.exports = __webpack_public_path__ + "img/energetic.952a3abb.jpg";